import SuccessIcon from "assets/icons/sent.svg"
import React, { useEffect } from 'react'
import { SuccessModalButton, SuccessModalContainer, SuccessModalContent, SuccessModalDescription, SuccessModalIcon, SuccessModalIconImg, SuccessModalTitle } from "./Theme"
const SuccessModal = ({
  title,
  description,
  btnText,
  btnAction,
  closeModal
}) => {


  useEffect(() => {
    setTimeout(() => {
      closeModal()
    }, 3000)
  }, [])




  return (
    <SuccessModalContainer>
      <SuccessModalContent>
        <SuccessModalIcon>
          <SuccessModalIconImg src={SuccessIcon} alt="Success Icon" />
        </SuccessModalIcon>
        <SuccessModalTitle>
          {title}
        </SuccessModalTitle>
        <SuccessModalDescription>
          {description}
        </SuccessModalDescription>
        <SuccessModalButton onClick={btnAction}>
          {btnText}
        </SuccessModalButton>
      </SuccessModalContent>
    </SuccessModalContainer>
  )
}

export default SuccessModal